// Import all images directly from your assets folder
import economyImg from "../assets/economy1.jpg";
import compactImg from "../assets/compact.jpg";
import midsizeImg from "../assets/Midsize.jpg";
import fullsizeImg from "../assets/Fullsize.jpg";
import suvImg from "../assets/SUVs.jpg";
import minivanImg from "../assets/Minivans.jpg";
import luxuryImg from "../assets/Luxury.jpg";
import pickupImg from "../assets/Pickup.jpg";

export const vehicleConfig = [
  {
    id: 1,
    image: economyImg,
    category: "RENTAL OPTION",
    title: "Economy Cars",
    subtitle: "Great for city driving",
    specs: {
      passengers: 4,
      bags: 2,
      transmission: "Automatic",
      fuel: "Fuel Efficient",
    },
    tags: ["BUDGET FRIENDLY", "FUEL EFFICIENT", "DAILY TRAVEL"],
    price: 25,
  },
  {
    id: 2,
    image: compactImg,
    category: "RENTAL OPTION",
    title: "Compact Cars",
    subtitle: "Easy to park and efficient",
    specs: {
      passengers: 4,
      bags: 2,
      transmission: "Automatic",
      fuel: "Fuel Efficient",
    },
    tags: ["EASY PARKING", "SMART VALUE", "CITY READY"],
    price: 29,
  },
  {
    id: 3,
    image: midsizeImg,
    category: "RENTAL OPTION",
    title: "Midsize Cars",
    subtitle: "Comfort for longer trips",
    specs: {
      passengers: 5,
      bags: 3,
      transmission: "Automatic",
      fuel: "Fuel Efficient",
    },
    tags: ["COMFORT CABIN", "ROAD TRIP READY", "SMART VALUE"],
    price: 35,
  },
  {
    id: 4,
    image: fullsizeImg,
    category: "RENTAL OPTION",
    title: "Fullsize Cars",
    subtitle: "Spacious cabin and smooth ride",
    specs: {
      passengers: 5,
      bags: 3,
      transmission: "Automatic",
      fuel: "Gasoline",
    },
    tags: ["ROOMY CABIN", "SMOOTH RIDE", "BUSINESS READY"],
    price: 45,
  },
  {
    id: 5,
    image: suvImg,
    category: "RENTAL OPTION",
    title: "SUVs",
    subtitle: "Power and space for the whole family",
    specs: {
      passengers: 5,
      bags: 4,
      transmission: "Automatic",
      fuel: "Gasoline",
    },
    tags: ["FAMILY FRIENDLY", "SPACIOUS", "OFF-ROAD READY"],
    price: 55,
  },
  {
    id: 6,
    image: minivanImg,
    category: "RENTAL OPTION",
    title: "Minivans",
    subtitle: "Maximum space for large groups",
    specs: {
      passengers: 7,
      bags: 5,
      transmission: "Automatic",
      fuel: "Gasoline",
    },
    tags: ["GROUP TRAVEL", "MAX SPACE", "COMFORT"],
    price: 65,
  },
  {
    id: 7,
    image: luxuryImg,
    category: "RENTAL OPTION",
    title: "Luxury Cars",
    subtitle: "Premium comfort and styling",
    specs: {
      passengers: 5,
      bags: 3,
      transmission: "Automatic",
      fuel: "Premium",
    },
    tags: ["PREMIUM TIER", "EXECUTIVE", "LUXURY CABIN"],
    price: 75,
  },
  {
    id: 8,
    image: pickupImg,
    category: "RENTAL OPTION",
    title: "Pickup Trucks",
    subtitle: "Utility and cargo capacity",
    specs: {
      passengers: 4,
      bags: 4,
      transmission: "Automatic",
      fuel: "Gasoline",
    },
    tags: ["UTILITY", "CARGO SPACE", "HEAVY DUTY"],
    price: 60,
  },
];
